import React from 'react'
import T from 'prop-types'
import { DragLayer } from 'react-dnd'

function collect(monitor) {
  var item = monitor.getItem()
  return {
    id: item && item.id,
    display: item && item.display,
    index: item && item.originalIndex,
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  }
}

function getItemStyles(currentOffset) {
  if (!currentOffset) {
    return {
      display: 'none'
    }
  }

  var x = currentOffset.x
  var y = currentOffset.y
  var transform = `translate(${x}px, ${y}px)`

  return {
    pointerEvents: 'none',
    transform: transform,
    WebkitTransform: transform
  }
}

class ItemPreview extends React.Component {
  static displayName = 'SortableMenu.ItemPreview'

  static propTypes = {
    currentOffset: T.shape({
      x: T.number,
      y: T.number
    }),
    display: T.string,
    findItem: T.func.isRequired,
    id: T.any,
    index: T.number,
    isDragging: T.bool
  }

  render() {
    const { display, currentOffset, isDragging } = this.props
    return isDragging
      ? <div
          className="sortable_menu_item item_preview"
          style={getItemStyles(currentOffset)}
        >
          <span className="icon icon-drag-handle" /> {display}
        </div>
      : <div />
  }
}

// @DragLayer(collect)
export default DragLayer(collect)(ItemPreview)
